import React, { useContext } from 'react';
import { HamburgerSqueeze } from 'react-animated-burgers';
import { ThemeContext } from 'styled-components';
import { StyledToggleButton } from './Button.styles';

type ButtonProps = {
  ariaLabel?: any;
  toggleMenu: () => void;
  isMenuOpen: boolean;
};

export const Button: React.FC<ButtonProps> = ({ ariaLabel, toggleMenu, isMenuOpen }) => {
  const themeContext = useContext(ThemeContext);
  const buttonColor = themeContext.defaultColors.fontPrimary;
  return (
    <StyledToggleButton onClick={toggleMenu} aria-label={ariaLabel}>
      <HamburgerSqueeze
        isActive={isMenuOpen}
        buttonStyle={{
          width: '44px',
          height: '44px',
          outline: 'none',
        }}
        buttonWidth={20}
        barColor={buttonColor}
      />
    </StyledToggleButton>
  );
};
